// extracted by mini-css-extract-plugin
export default {"card":"AccountActivities_card__I2Eg8","tabs":"AccountActivities_tabs__ge-7P","active":"AccountActivities_active__pvjEN"};